import React from "react";

import facebook_img from "../assets/Facebook F.png";
import instagram_img from "../assets/Instagram.png";
import linkedIn_img from "../assets/LinkedIn 2.png";
import youtube_img from "../assets/YouTube.png";
import { classNames } from "../helpers";
import { cleanHandleInput, SOCIAL_PLATFORMS } from "../utils/socialLinks";

/**
 * Social handle field (2026-10-28): the club types only the handle / page name; the platform's address is shown
 * in front of it ("instagram.com/" yourclub). Saved as a full link with utils/socialLinks.linkFromHandle.
 */

const IMAGES = { facebook: facebook_img, instagram: instagram_img, linkedIn: linkedIn_img, youtube: youtube_img };

/** Platform logo. Twitter is X now: the X mark. */
export function SocialIcon({ platform, className = "h-5 w-5" }) {
  if (platform === "twitter") {
    return (
      <svg viewBox="0 0 24 24" className={classNames(className, "text-gray-900")} fill="currentColor" aria-hidden="true">
        <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
      </svg>
    );
  }
  const src = IMAGES[platform];
  return src ? <img src={src} alt="" className={classNames(className, "object-contain")} aria-hidden="true" /> : null;
}

/**
 * Settings style (Account settings → Club): icon + label on the left, "<address>/" + handle in one rounded field.
 * value / onChange work with the handle only.
 */
export function SocialHandleInput({ platform, value, onChange, idPrefix = "club" }) {
  const p = SOCIAL_PLATFORMS[platform];
  if (!p) return null;
  const id = `${idPrefix}-${platform}`;
  return (
    <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-3">
      <label htmlFor={id} className="flex w-40 shrink-0 items-center gap-3 text-sm font-extrabold text-gray-900">
        <span aria-hidden="true" className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white">
          <SocialIcon platform={platform} />
        </span>
        {p.label}
      </label>
      <div className="flex min-w-0 flex-1 items-center rounded-2xl border border-gray-200 bg-white px-4 transition focus-within:border-indigo-bz focus-within:ring-4 focus-within:ring-[#F3E9FF]">
        <span className="shrink-0 select-none text-base text-gray-400" aria-hidden="true">{p.prefix}</span>
        <input
          id={id}
          type="text"
          inputMode="text"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          placeholder="yourclub"
          aria-label={`${p.label} handle or page name`}
          value={value || ""}
          onChange={(e) => onChange(cleanHandleInput(platform, e.target.value))}
          className="block w-full min-w-0 bg-transparent py-3 pl-0.5 pr-0 text-base text-gray-900 placeholder:text-gray-400 outline-none"
        />
      </div>
    </div>
  );
}
